import {
  dispatch,
  DispatchList,
  DispatchNoteStatus,
  getSelectedItems,
  updateSelectedItemsMap,
  useAppSelector,
} from '@zonofi/zono-money-store';
import React from 'react';
import { TouchableOpacity } from '../../common';
import moment from 'moment';
import { SVGS } from '../../assets';
import { Divider, StatusBadge } from '../../components';
import { DividerColorVariant } from '../../constants';
import './dispatch-note-card.scss';
import { ReactComponent as Checkbox } from '@zonofi/svg-icons/checkbox.svg';
import { ReactComponent as Checked } from '@zonofi/svg-icons/checked.svg';

interface DispatchNoteCardProps {
  item?: DispatchList;
  onDispatchNotePress?: () => void;
  isDisable?: boolean;
  showDeletion?: boolean;
  onDeletePress?: (val: DispatchList) => void;
  showSelection?: boolean;
}

export const DispatchNoteCard: React.FC<DispatchNoteCardProps> = ({
  item = {} as DispatchList,
  onDispatchNotePress = () => {},
  isDisable = false,
  showDeletion = false,
  onDeletePress = () => {},
  showSelection = false,
}) => {
  const selectedDispatchNotetems = useAppSelector(getSelectedItems);
  const isSelected = selectedDispatchNotetems.some(
    (selected) => selected.id === item.id
  );

  return (
    <TouchableOpacity
      className="dispatch-note-card"
      onPress={() => {
        onDispatchNotePress();
      }}
      disabled={isDisable}
      allowAnimation={false}
    >
      <div className="dispatch-note-card-content">
        <div className="dispatch-note-card-content-header">
          <div className="dispatch-note-card-content-header-top">
            <div className="dispatch-note-card-content-header-top-left">
              {showSelection &&
                (isSelected ? (
                  <Checked
                    className="dispatch-note-card-content-header-top-left-checkbox"
                    color={'#000000'}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      dispatch(updateSelectedItemsMap(item));
                    }}
                  />
                ) : (
                  <Checkbox
                    className="dispatch-note-card-content-header-top-left-checkbox"
                    color={'#8C8C8C'}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      dispatch(updateSelectedItemsMap(item));
                    }}
                  />
                ))}
              <img
                src={SVGS.DispatchNoteNotFound}
                alt="invoice pending"
                width={36}
                height={36}
              />
              <div className="dispatch-note-card-content-header-top-left-info font-semibold">
                <span className="dispatch-note-card-content-header-top-left-info-number font-semibold">
                  {item?.dispatchDocNumber}
                </span>
                <div className="dispatch-note-card-content-header-top-left-info-boxes font-regular">
                  <span className="font-regular">
                    {moment(item?.dispatchDate).format('DD/MM/YYYY')}
                  </span>
                  •
                  <span className="font-regular">{`${item?.numOfBoxes} Boxes`}</span>
                </div>
              </div>
            </div>
            <div className="dispatch-note-card-content-header-top-right">
              <StatusBadge
                status={item?.status}
                style={{
                  backgroundClass: `${
                    item?.status === DispatchNoteStatus.Dispatched
                      ? 'dispatched'
                      : 'delivered'
                  }`,
                  textClass: `${
                    item?.status === DispatchNoteStatus.Dispatched
                      ? 'dispatched'
                      : 'delivered'
                  }`,
                }}
              />
              {showDeletion && (
                <TouchableOpacity
                  className="dispatch-note-card-content-header-top-right-img"
                  onPress={() => onDeletePress?.(item)}
                >
                  <img
                    src={SVGS.DeleteIcon}
                    alt="remove invoice from selection"
                  />
                </TouchableOpacity>
              )}
            </div>
          </div>
        </div>

        <Divider
          className="dispatch-note-card-content-divider"
          colorVariant={DividerColorVariant.PRIMARY}
        />

        <div className="dispatch-note-card-content-data">
          <span className="dispatch-note-card-content-data-key font-semibold">
            Customer:{' '}
            <span className="dispatch-note-card-content-data-key-value font-regular">
              {item?.customerName || 'N/A'}
            </span>
          </span>
          <span className="dispatch-note-card-content-data-key font-semibold">
            Phone Number:{' '}
            <span className="dispatch-note-card-content-data-key-value font-regular">
              {item?.driverPhone || 'N/A'}
            </span>
          </span>
          <span className="dispatch-note-card-content-data-key font-semibold">
            Delivery Date:{' '}
            <span className="dispatch-note-card-content-data-key-value font-regular">
              {item?.deliveryDate
                ? moment(item?.deliveryDate).format('DD/MM/YYYY')
                : 'N/A'}
            </span>
          </span>
        </div>
      </div>
    </TouchableOpacity>
  );
};
